// extracted by mini-css-extract-plugin
export var fadeInAnimation = "DesktopCalculator-module--fadeInAnimation--46a40";
export var wrapper = "DesktopCalculator-module--wrapper--e0bba";